export default __webpack_public_path__ + "static/14-c801482e6da87d7c85637fedd6ba1a5a.jpg";